import chest from '@/assets/aurora/home-illustrations-v1/chest.webp'
import calendar from '@/assets/aurora/home-illustrations-v1/calendar.webp'
import wheel from '@/assets/aurora/home-illustrations-v1/wheel.webp'
import diamond from '@/assets/aurora/home-illustrations-v1/diamond.webp'
import gift from '@/assets/aurora/home-illustrations-v1/gift.webp'
import users from '@/assets/aurora/home-illustrations-v1/users.webp'
import ticket from '@/assets/aurora/home-illustrations-v1/ticket.webp'
import chat from '@/assets/aurora/home-illustrations-v1/chat.webp'
import headset from '@/assets/aurora/home-illustrations-v1/headset.webp'
import coins from '@/assets/aurora/home-illustrations-v1/coins.webp'
import shield from '@/assets/aurora/home-illustrations-v1/shield.webp'
import envelope from '@/assets/aurora/home-illustrations-v1/envelope.webp'
import trophy from '@/assets/aurora/home-illustrations-v1/trophy.webp'
import flame from '@/assets/aurora/home-illustrations-v1/flame.webp'
import slots from '@/assets/aurora/home-illustrations-v1/slots.webp'
import clock from '@/assets/aurora/home-illustrations-v1/clock.webp'
import heart from '@/assets/aurora/home-illustrations-v1/heart.webp'
import menu from '@/assets/aurora/home-illustrations-v1/menu.webp'
import home from '@/assets/aurora/home-illustrations-v1/home.webp'
import account from '@/assets/aurora/home-illustrations-v1/account.webp'
import megaphone from '@/assets/aurora/home-illustrations-v1/megaphone.webp'

// Only built-in navigation artwork is local. API-supplied custom images stay in their original components.
export const illustrations = {
    chest,
    calendar,
    wheel,
    diamond,
    gift,
    users,
    ticket,
    chat,
    headset,
    coins,
    shield,
    envelope,
    trophy,
    flame,
    slots,
    clock,
    heart,
    menu,
    home,
    account,
    megaphone,
    providers: menu
}
